(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hc-promo"] && !Shopify.designMode) return;
  try {
    (function () {
    // Copie synchrone d'abord (dans le geste du clic), navigator.clipboard en secours :
    // dans un navigateur intégré, writeText peut rester en attente sans jamais répondre.
    function copier(texte) {
      var ok = false, zone = document.createElement('textarea');
      zone.value = texte; zone.setAttribute('readonly', '');
      zone.style.cssText = 'position:fixed;top:-9999px;opacity:0';
      document.body.appendChild(zone); zone.select();
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(zone);
      if (ok) return Promise.resolve();
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(texte);
      return Promise.reject();
    }

    // Shopify sert les pages depuis son cache : le code choisi par Liquid peut dater de la
    // veille au changement de période. On recalcule donc ici, à l'heure réelle.
    // Test : ?promo_date=2026-11-07T10:00 simule une date (affichage seul).
    function maintenant() {
      var m = /[?&]promo_date=([^&]+)/.exec(window.location.search);
      var t = m ? new Date(decodeURIComponent(m[1])).getTime() : NaN;
      return Math.floor((isNaN(t) ? Date.now() : t) / 1000);
    }

    function actualiser() {
      var t = maintenant();
      document.querySelectorAll('.hcf-code[data-cal]').forEach(function (b) {
        var d = (b.getAttribute('data-defaut') || '|').split('|');
        var sur = d[0], code = d[1];
        var nom = '', fin = '';
        b.getAttribute('data-cal').split(';').some(function (l) {
          var c = l.split('|');
          if (t >= +c[0] && t <= +c[1]) { code = c[2]; sur = c[3]; nom = c[4] || ''; fin = c[5] || ''; return true; }
          return false;
        });
        // N'écrire que ce qui change : l'observateur verrait sinon ses propres écritures.
        if (b.dataset.code === code && b.dataset.vu) return;
        b.dataset.vu = '1';
        b.dataset.code = code;
        b.hidden = !code;
        var rs = b.querySelector('[data-ref="sur"]'), rc = b.querySelector('[data-ref="code"]');
        if (rs && rs.textContent !== sur) rs.textContent = sur;
        if (rc && rc.textContent !== code) rc.textContent = code;
        // 02-11 offre de campagne : nom, fin et remise de la période (ou retour au rendu sobre hors période).
        b.classList.toggle('hcf-code--offre', !!nom);
        var po = { nom: nom, jour: fin.split(' ')[0] + ' ', fin: fin.split(' ').slice(1).join(' '), remise: '\u2212' + sur.split(' sur ')[0].replace(/^[-\u2212]\s*/, '').replace(/ /g, '\u00a0') };
        Object.keys(po).forEach(function (k) {
          var e = b.querySelector('[data-ref="' + k + '"]');
          if (e && e.textContent !== po[k]) e.textContent = po[k];
        });
        b.setAttribute('aria-label', sur + ' — ' + (b.dataset.copier || '') + ' ' + code);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', actualiser);
    else actualiser();
    // La fiche re-rend ses blocs au changement de variante : on repasse, une fois par image au plus.
    var attente = false;
    new MutationObserver(function () {
      if (attente) return; attente = true;
      requestAnimationFrame(function () { attente = false; actualiser(); });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('click', function (e) {
      var b = e.target.closest('.hcf-code');
      if (!b || b.classList.contains('is-copied')) return;
      copier(b.dataset.code).then(function () {
        var a = b.querySelector('[data-ref="action"]'), ann = b.querySelector('[data-ref="annonce"]');
        var avant = a ? a.textContent : '';
        b.classList.add('is-copied');
        if (a) a.textContent = b.dataset.copie;
        if (ann) ann.textContent = b.dataset.copie;
        setTimeout(function () {
          b.classList.remove('is-copied');
          if (a) a.textContent = avant;
          if (ann) ann.textContent = '';
        }, 2000);
      }).catch(function () {});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["promo-code"] && !Shopify.designMode) return;
  try {
    (function () {
    function copier(texte) {
      // Copie synchrone d'abord (<textarea> + execCommand, dans le geste du clic), l'API
      // navigator.clipboard seulement en secours. Inversé le 2026-10-13 : dans un navigateur
      // intégré, writeText peut rester EN ATTENTE sans jamais répondre, et le bouton ne
      // passait jamais à « Copié ! » (constaté en test, même défaut sur le bandeau).
      var ok = false;
      var zone = document.createElement('textarea');
      zone.value = texte;
      zone.setAttribute('readonly', '');
      zone.style.cssText = 'position:fixed;top:-9999px;opacity:0';
      document.body.appendChild(zone);
      zone.select();
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(zone);
      if (ok) return Promise.resolve();
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(texte);
      return Promise.reject();
    }

    // Recalcule la période active dans le navigateur (voir le commentaire en tête).
    function maintenant() {
      var m = /[?&]promo_date=([^&]+)/.exec(window.location.search);
      var t = m ? new Date(decodeURIComponent(m[1])).getTime() : NaN;
      return Math.floor((isNaN(t) ? Date.now() : t) / 1000);
    }

    function actualiser(racine) {
      var t = maintenant();
      (racine || document).querySelectorAll('.promo-code[data-calendrier]').forEach(function (bouton) {
        var d = bouton.dataset.defaut.split('|');
        var remise = d[0], label = d[1], code = d[2];
        bouton.dataset.calendrier.split(';').some(function (ligne) {
          var c = ligne.split('|');
          if (t >= +c[0] && t <= +c[1]) {
            remise = c[2]; label = 'sur votre commande'; code = c[5];
            return true;
          }
          return false;
        });
        if (!code) { bouton.hidden = true; return; }
        // N'écrire que ce qui change : l'observateur ci-dessous verrait sinon ses propres
        // écritures et tournerait en boucle.
        if (bouton.dataset.code === code && bouton.dataset.actualise) return;
        bouton.dataset.actualise = '1';
        var eyebrow = bouton.querySelector('[data-ref="eyebrow"]');
        var valeur = bouton.querySelector('[data-ref="valeur"]');
        if (eyebrow) eyebrow.textContent = remise + ' ' + label;
        if (valeur) valeur.textContent = code;
        bouton.dataset.code = code;
        bouton.setAttribute('aria-label', remise + ' ' + label + ' — ' + bouton.dataset.copier + ' ' + code);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { actualiser(); });
    } else {
      actualiser();
    }
    // La page produit re-rend ses blocs au changement de variante : on repasse dessus,
    // une fois par image au plus.
    var enAttente = false;
    new MutationObserver(function () {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () { enAttente = false; actualiser(); });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('click', function (evenement) {
      var bouton = evenement.target.closest('.promo-code');
      if (!bouton || bouton.classList.contains('is-copied')) return;

      copier(bouton.dataset.code).then(function () {
        var texte = bouton.querySelector('[data-ref="action-text"]');
        var annonce = bouton.querySelector('[data-ref="annonce"]');
        var avant = texte ? texte.textContent : '';

        bouton.classList.add('is-copied');
        if (texte) texte.textContent = bouton.dataset.copie;
        if (annonce) annonce.textContent = bouton.dataset.copie;

        setTimeout(function () {
          bouton.classList.remove('is-copied');
          if (texte) texte.textContent = avant;
          if (annonce) annonce.textContent = '';
        }, 2000);
      }).catch(function () {
        // Copie refusée : on ne casse rien, le code reste lisible et sélectionnable.
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
